import angular from "angular";
import component from './stations-control.component';
import syncStations from "./sync-stations/sync-stations.component";
import stationsEdit from "./stations-edit/stations-edit.component";

angular.module('stationsControl', [
    component,
    syncStations,
    stationsEdit
]);

export default 'stationsControl';



// WEBPACK FOOTER //
// ./resources/assets/modules/stations-control/stations-control.module.js